import { render, staticRenderFns } from "./GridHistory.vue?vue&type=template&id=2a6eb6e8"
import script from "./GridHistory.vue?vue&type=script&lang=js"
export * from "./GridHistory.vue?vue&type=script&lang=js"
import style0 from "./GridHistory.vue?vue&type=style&index=0&id=2a6eb6e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports